import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  createFilterOptions,
  MenuItem,
  Select,
  Paper,
  CircularProgress,
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { DesktopDatePicker } from "@mui/lab";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useSelector } from "react-redux";
import ErrorProps from "../../../Component/Errorprops";
import { toast } from "react-toastify";
import { defaultInfo } from "../../../ConfigInfo/Info";
const PersonModal = ({ mode, handleCloseClick, editData }) => {
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);
  console.log("loginInfo", siteInfoDetail);
  const [loading, setLoading] = useState(false);
  const [org, setOrgId] = useState([]);
  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };
  const isOraAdmin = siteInfoDetail?.roleName === "Ora Admin";
  const eamAdmin = siteInfoDetail?.roleName === defaultInfo.roleName.eamSuperAdmin;
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    const link = masterAPI["organization"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false);
        setOrgId(res.data.result);
      })
      .catch((e) => {
        setOrgId([]);
        setLoading(false);
        console.log(e, "siteerror");
      });
  };
  const initialValue = {
    code: mode === "Edit" ? editData.code : "",
    personName: mode === "Edit" ? editData.personName : "",
    title: mode === "Edit" ? editData.title : "",
    email: mode === "Edit" ? editData.email : "",
    mobileNo: mode === "Edit" ? editData.mobileNo : "",
    telephonne: mode === "Edit" ? editData.telephonne : "",
    organizationId:
      !eamAdmin
        ? siteInfoDetail.organizationId
        : mode === "Edit"
        ? editData.organizationId
        : "",
  };

  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    const createLink = masterAPI["person"].create;
    const updateLink = masterAPI["person"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, value)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
            // toast.error(e.response.data.failureMessage)
          console.log(e, "create person");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...value,
      };
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
            if(e.response.data.FailureMessage)
                    {
                            // toast.error("Code is already exists")
                    }
          console.log(e, "update person");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };
 const validationSchema = Yup.object().shape({

  code:Yup.string().required("Code is required"),
  personName:Yup.string().required("Person Name is required"),
    title:Yup.string().required("Title is required"),
        email:Yup.string().required("Email is required"),
        mobileNo:Yup.string().required("Mobile No is required"),
          telephonne:Yup.string().required("Telephonne No is required"),
            organizationId:Yup.string().required("Organization is required"),
 });
  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? editData.code + "-" + editData.personName
            : "New Person"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue}validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Organization
                </Typography>
                <Autocomplete
                  value={
                    org.find(
                      (p) =>
                        p.id ===
                          (!eamAdmin
                            ? siteInfoDetail.organizationId
                            : values.organizationId)
                    ) || null
                  }
                  fullWidth
                  filterOptions={filterOptions}
                  loading={org.length === 0}
                  options={org}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.code + " - " + option.organizationName || option
                  }
                  freeSolo={!eamAdmin}
                  disabled={!eamAdmin}
                  onChange={(event, value) => {
                    if (value !== null) {
                      // getSite(value.id);
                      setFieldValue("organizationId", value.id);
                    }
                  }}
                  // onInputChange={(event, newInputValue) => {
                 
                  // }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="organizationId"
                      placeholder="Select Organization"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {org.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
                  <ErrorMessage name="organizationId">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Person Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Person code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                       <ErrorMessage name="code">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Person Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="personName"
                  placeholder="Enter Person Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                       <ErrorMessage name="personName">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Title
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="title"
                  placeholder="Enter Title"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="title">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  email
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="email"
                  placeholder="Enter Email"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                 <ErrorMessage name="email">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Mobile Number
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="mobileNo"
                  placeholder="Enter Mobile Number"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                    <ErrorMessage name="mobileNo">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Telephone
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="telephonne"
                  placeholder="Enter TelePhone"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                  <ErrorMessage name="telephonne">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default PersonModal;
